import { useQuery } from '@tanstack/react-query'

import { type DocumentReport } from './useMainQuery'
import { useMainQueryKey } from './useMainQueryKey'

export const useMainQueryData = () => {
  const queryKey = useMainQueryKey()

  const { data } = useQuery<DocumentReport>({ enabled: false, queryKey })

  return data
}
